import { get, writable } from 'svelte/store';
import type { User } from '$lib/types/User';
import type { BackOfficeUser } from '$lib/types/BackOfficeUser';

export const userStore = writable<User | null>(null);
export const backofficeUserStore = writable<BackOfficeUser | null>(null);

export const setSessid = (sessid: string) => {
    localStorage.setItem('sessid', sessid)
}
export const getSessid = () => {
    return localStorage.getItem('sessid')
}

export const isImpersonated = () => {
    return get(userStore)?.isImpersonated
}

export const isBoAdmin = () => {
    return get(backofficeUserStore)?.role === 'admin';
}